module.exports = __webpack_public_path__ + "static/media/mic_btn_normal.2f1ef5fa.svg";